export default "__VITE_ASSET__Cj9BjI4M__"